// Коды локалей проекта. Единая точка правды для сравнений вида `locale.value === LocaleCode.EN`.
export const LocaleCode = {
  EN: 'en',
  ES: 'es',
  ES_MX: 'es-mx',
  PT: 'pt',
  PT_BR: 'pt-br',
  DE: 'de',
  FR: 'fr',
  IT: 'it',
} as const;

export type LocaleCodeValue = typeof LocaleCode[keyof typeof LocaleCode];
